import React from "react";

export default function FloatingInputBox({type,id,placeholder,label,value,onChange,maxLength,pattern,readOnly,title,autoComplete}){
    return (
        <div className="form-floating">
                <input type={type} className="form-control" id= {id} 
                placeholder= { placeholder } value={value} onChange={onChange} 
                maxLength={maxLength} pattern={pattern} readOnly={readOnly} title={title} autoComplete= {autoComplete} />
                <label htmlFor={id}>{label}</label>
            </div>
    );
}